/* eslint-disable */
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

// Types
import { TCustomGFIActionProps } from '@/@types/views/map';

// Custom
import MapCardActionButton from '@/ui/MapCard/MapCardActionButton';
import Permissions from '@/lib/permissions';
import { get3DTargetPosition, get3DUrl } from './show3DTarget';

// MUI
import LaunchIcon from '@mui/icons-material/Launch';
import useApi from '@/lib/api/useApi';
import { DCRecord } from '@/@types/lib/dataController';

const Show3DButton = (props: TCustomGFIActionProps) => {
  const { t } = useTranslation();

  const { featureData } = props;

  const apiInstance = useApi();

  const [isIn3D, setIsIn3D] = React.useState(false);

  const handleShow3D = () => {
    window.open(get3DUrl(featureData), '_blank');
  };

  useEffect(() => {
    const [x, y] = get3DTargetPosition(featureData);
    apiInstance.get(`threeD/is-in-3d?x=${x}&y=${y}`).then((resp) => {
      if (resp.success && resp.data) {
        setIsIn3D(!!((resp.data as DCRecord).inside));
      } else {
        setIsIn3D(false);
      }
    }).catch(() => setIsIn3D(false));
  }, [featureData])

  return (
    <MapCardActionButton
      onClick={handleShow3D}
      aria-label="3d"
      disabled={!isIn3D}
      sx={{ minWidth: '40px' }}
      needPermission={[Permissions.ThreeDView]}
      tooltip={t("buttons.show_3d") as string}
    >
        <span style={{fontWeight:700}}>3D</span>
      <LaunchIcon style={{ marginLeft: '7px', width: '16px', height: '16px' }} />
    </MapCardActionButton>
  );
};

export default Show3DButton;
